<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>派送方式</span>
            <div>
              <el-button type="primary" size="small" @click="openAddDistributionModeModal">
                <i class="el-icon-plus"></i>添加
              </el-button>
            </div>
          </div>
          <el-table
            :data="distributionModeManageInfo.distributionModes"
            style="width: 100%"
            border
            stripe
          >
            <el-table-column prop="modeId" label="派送方式ID" align="center"></el-table-column>
            <el-table-column prop="modeName" label="方式名称" align="center"></el-table-column>
            <el-table-column prop="fixedFee" label="固定费" align="center">
              <template slot-scope="scope">
                {{scope.row.fixedFee === '-1.00' ? '-' : scope.row.fixedFee}}
              </template>
            </el-table-column>
            <el-table-column prop="startDeliveryIn" label="起送1公里内" align="center">
              <template slot-scope="scope">
                {{scope.row.startDeliveryIn === '-1.00' ? '-' : scope.row.startDeliveryIn}}
              </template>
            </el-table-column>
            <el-table-column prop="startDeliveryOut" label="起送1公里后每公里" align="center">
              <template slot-scope="scope">
                {{scope.row.startDeliveryOut === '-1.00' ? '-' : scope.row.startDeliveryOut}}
              </template>
            </el-table-column>
            <el-table-column prop="maximumDistribution" label="最大配送公里" align="center">
              <template slot-scope="scope">
                {{scope.row.maximumDistribution === '-1.00' ? '-' : scope.row.maximumDistribution}}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" @click="openEditDistributionModeModel(scope.row)">修改</el-button>
                  <el-button size="mini" type="danger" @click="openDeleteDistributionModeModel(scope.row)">删除</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="distributionModeManageInfo.total"
            style="margin-top: 20px; text-align: right;"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <add-distribution-mode ref="addDistributionMode"></add-distribution-mode>
    <edit-distribution-mode ref="editDistributionMode"></edit-distribution-mode>
    <delete-distribution-mode ref="deleteDistributionMode"></delete-distribution-mode>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { listDistributionMode } from '@/api/goods/distributionModeApi'
import AddDistributionMode from '@/components/goods/addDistributionMode/addDistributionMode'
import EditDistributionMode from '@/components/goods/editDistributionMode/editDistributionMode'
import DeleteDistributionMode from '@/components/goods/deleteDistributionMode/deleteDistributionMode'

export default {
  name: 'DistributionModeManage',
  components: {
    AddDistributionMode,
    EditDistributionMode,
    DeleteDistributionMode
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      distributionModeManageInfo: {
        distributionModes: [],
        total: 0,
        conditions: {
          modeId: '',
          modeName: '',
          shopId: '',
          statusCd: ''
        }
      }
    }
  },
  created() {
    this.listDistributionModes(this.currentPage, this.pageSize)
  },
  methods: {
    async listDistributionModes(page, rows) {
      this.distributionModeManageInfo.conditions.page = page
      this.distributionModeManageInfo.conditions.row = rows
      this.distributionModeManageInfo.conditions.shopId = getShopId()
      console.log(this.distributionModeManageInfo.conditions)
      
      try {
        const res = await listDistributionMode(this.distributionModeManageInfo.conditions)
        this.distributionModeManageInfo.distributionModes = res.data
        this.distributionModeManageInfo.total = res.total
      } catch (error) {
        console.error('获取派送方式列表失败:', error)
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.listDistributionModes(this.currentPage, this.pageSize)
    },
    openAddDistributionModeModal() {
      this.$refs.addDistributionMode.open()
    },
    openEditDistributionModeModel(row) {
      this.$refs.editDistributionMode.open(row)
    },
    openDeleteDistributionModeModel(row) {
      this.$refs.deleteDistributionMode.open(row)
    }
  }
}
</script>

<style scoped>
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
</style>